<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <label class="title">调查员质疑处理统计</label>            
          </a-col>
        </a-row>
      </a-form>
    </div>    
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleView(record)">查看</a>
        </span>        
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  export default {
    name: "questinCount",
    mixins: [JeecgListMixin],
    components: {

    },
    props:['centerId'],
    data() {
      return {
        registerDateRange:[],
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        columns: [
          {
            title: '采集员',
            align: "center",
            dataIndex: 'realName',
            width: 120,
          },
          {
            title: '系统质疑',
            align: "center",
            children: [
              {
                title: '已处理',
                align: "center",
                width: 100,
                dataIndex: 'systemHandle',
              },
              {
                title: '未处理',
                align: "center",
                width: 120,
                dataIndex: 'systemNotHandle',
              },
              {
                title: '处理率',
                align: "center",
                width: 120,
                dataIndex: 'systemRate',
              },
            ]
          },
          {
            title: '人工质疑',
            align: "center",
            children: [
              {
                title: '已处理',
                align: "center",
                width: 120,
                dataIndex: 'personHandle',
              },
              {
                title: '未处理',
                align: "center",
                width: 120,
                dataIndex: 'personNotHandle',
              },
              {
                title: '处理率',
                align: "center",
                width: 100,
                dataIndex: 'personRate',
              },
            ]
          },          
        ],
        url: {
          list: "/project/statistic/question/handle",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.columns.push({
          title: '详情',
          dataIndex: 'action',
          width: 120,
          align: "center",
          fixed:'right',
          scopedSlots: {customRender: 'action'}
        })
      this.queryParam.projectId = this.projectId
      this.loadData()
    },
    watch:{
    },
    methods: {
      handleView(record){
        console.log(record)
        this.$router.push({
          path:'/project/datacheck/Question/',
          query:{userId:record.userId}
        })
      },
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
  .info{
    color: @primary-color;
  }
</style>
